/**
 * Bill Credits Saga
 */
import { call, put, takeEvery } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import UserAPI from '../../Lib/Api/user';
import { handleError } from '../../Lib/Utils/saga-utils';

const { BillCredit, BillCredits } = Constants;
const {
  getBillCreditsError,
  getBillCreditsSuccess,
  getBillCreditError,
  getBillCreditSuccess,
} = Actions;

/**
 * Gets bill credits and dispatches success or error.
 *
 *  @param {object} action:
 *  {
 *    @property {string} userId: the user id
 *    @property {string} params: query params
 *  }
 */
export function* getBillCredits({ userId, params }) {
  try {
    const response = yield call(UserAPI.getBillCredits, userId, params);
    yield put(getBillCreditsSuccess(response));
  } catch (err) {
    yield handleError(getBillCreditsError, err);
  }
}

/**
 * Gets bill credits and dispatches success or error.
 *
 *  @param {object} action:
 *  {
 *    @property {string} userId: the user id
 *  }
 */
export function* getBillCredit({ userId, billCreditId }) {
  try {
    const response = yield call(UserAPI.getBillCredit, userId, billCreditId);
    yield put(getBillCreditSuccess(response));
  } catch (err) {
    yield handleError(getBillCreditError, err);
  }
}

function* billCreditSaga() {
  yield takeEvery(BillCredits.GET_BILL_CREDITS, getBillCredits);
  yield takeEvery(BillCredit.GET_BILL_CREDIT, getBillCredit);
}

export default billCreditSaga;
